export default "__VITE_ASSET__4Jt77b25__"